import { loginRegister } from './login-register-de.i18n';

export const de = {
  loginRegister,
};
